import { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import asyncThunks from '../async-thunks';
import { ApiState } from '../types';

const pauseUnpauseMachineRequest = (
  builder: ActionReducerMapBuilder<ApiState>,
) => {
  builder.addCase(
    asyncThunks.pauseUnpauseMachineRequest.pending,
    (state: ApiState) => {
      state.isLoading = true;
      state.isError = false;
    },
  );
  builder.addCase(
    asyncThunks.pauseUnpauseMachineRequest.fulfilled,
    (state: ApiState) => {
      state.isLoading = false;
      state.isError = false;
    },
  );
  builder.addCase(
    asyncThunks.pauseUnpauseMachineRequest.rejected,
    (state: ApiState) => {
      state.isLoading = false;
      state.isError = true;
    },
  );
};

export default pauseUnpauseMachineRequest;
